import React from 'react'

function IfYouHaveAnyQuestions({userProfile}) {
  if (!userProfile) {
    return null
  }
  return (userProfile.forCosco)
      ?  (
          <span>If you have any questions on the last free date and demurrage charges displayed on this page due to container inaccessibility at the marine terminal or any other reason, please contact COSCO at <a
              href="https://support.cosco-usa.com/support/home">https://support.cosco-usa.com/support/home</a> for review and adjustment.</span>
      ) : null
}

export default IfYouHaveAnyQuestions
